export default __webpack_public_path__ + "static/media/mic_off.f06fda6a.svg";